// 履约脱敏/解密工具函数
import CryptoJS from 'crypto-js/crypto-js';
import { decrypt } from './cryptoJs';

const DECRYPT_KEY = CryptoJS.enc.Utf8.parse('51f77e2832e74a6eba529d597f4e1c2b');

// 脱敏字段对应的秘钥key
export const getSecretKey = function (key) {
    const SUFFIX = 'Encrypted'; // 脱敏字段明文字段的后缀
    return key + SUFFIX;
};

// 提取脱敏字段对应的秘钥
export const extractSecret = function (row, config) {
    const { columns = [] } = config.table || {};
    // 脱敏的字段
    return columns.filter(item => {
        return item.type === 'desensitized';
    }).map(item => item.prop).reduce((acc, key) => {
        acc[key] = row[getSecretKey(key)];
        return acc;
    }, {});
};

/** 对行数据进行解密
 * @param { object } row 行数据
 * @param { object } config 表格配置对象
 * @returns { row: object, radiate: function }
*/
export const reveal = function (row, config) {
    const donedArr = [];
    if (row.desensitizationFlag) {
        // 行数据脱敏标志=true，才需要进行解密处理
        const secretMap = extractSecret(row, config);
        Object.keys(secretMap).forEach(key => {
            if (secretMap[key]) {
                row[key] = decrypt(secretMap[key], { key: DECRYPT_KEY });
            }
        });
        row.desensitizationFlag = false; // 修改脱敏标识，隐藏眼睛图标
        donedArr.push(row);
    }

    const obj = {
        /**
         * 解密列表中的相同数据行
         * @param { Array } list
         * @param { Array } compareKeys 相同行判断：比对字段列表（全相等则认为相同行）
         * @returns { object }
         */
        radiate: function (list, compareKeys) {
            list.forEach(item => {
                const isSame = compareKeys.every(k => {
                    return Reflect.has(item, k) && Reflect.has(row, k) && item[k] === row[k];
                });

                if (isSame && row !== item) {
                    reveal(item, config).done(rows => donedArr.push(...rows));
                }
            });
            return obj;
        },
        /** 完成回调 */
        done(handle) {
            if (typeof handle === 'function') {
                handle(donedArr);
            }
        }
    };

    return obj;
};

// 批量解密
export const batchReveal = function (list, config) {
    const donedArr = [];
    list.forEach(row => reveal(row, config).done(rows => donedArr.push(...rows)));
    return {
        done(handle) {
            if (typeof handle === 'function') {
                handle(donedArr);
            }
        }
    };
};
